/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../axios-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { PostApiBarberAppointmentsIdNoShowMutationResponse, PostApiBarberAppointmentsIdNoShowPathParams, PostApiBarberAppointmentsIdNoShow400, PostApiBarberAppointmentsIdNoShow401, PostApiBarberAppointmentsIdNoShow403, PostApiBarberAppointmentsIdNoShow404, PostApiBarberAppointmentsIdNoShow500 } from "../entities/PostApiBarberAppointmentsIdNoShow";

function getPostApiBarberAppointmentsIdNoShowUrl(id: PostApiBarberAppointmentsIdNoShowPathParams["id"]) {
  const res = { method: 'POST', url: `/api/barber/appointments/${id}/no-show` as const }
  return res
}

/**
 * @description Отметить запись как неявку клиента
 * @summary Клиент не пришел
 * {@link /api/barber/appointments/:id/no-show}
 */
export async function postApiBarberAppointmentsIdNoShow(id: PostApiBarberAppointmentsIdNoShowPathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<PostApiBarberAppointmentsIdNoShowMutationResponse, ResponseErrorConfig<PostApiBarberAppointmentsIdNoShow400 | PostApiBarberAppointmentsIdNoShow401 | PostApiBarberAppointmentsIdNoShow403 | PostApiBarberAppointmentsIdNoShow404 | PostApiBarberAppointmentsIdNoShow500>, unknown>({ method : "POST", url : getPostApiBarberAppointmentsIdNoShowUrl(id).url.toString(), ... requestConfig })
  return res.data
}